import React from "react";
import { Main } from "../components/sections/products/Main";

export const Products = () => {
  return <Main />;
};
